/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { FormRepresentation, ResultListDataRepresentationFormRepresentation } from '../model';
import { BaseApi } from './base.api';
import { buildCollectionParam } from '../../../alfrescoApiClient';
import { throwIfNotDefined } from '../../../assert';
export class FormModelsApi extends BaseApi {
    getFormEditorJson(formId) {
        throwIfNotDefined(formId, 'formId');
        const pathParams = {
            formId
        };
        return this.get({
            path: '/api/enterprise/forms/{formId}/editorJson',
            pathParams
        });
    }
    getFormHistory(formId, formHistoryId) {
        throwIfNotDefined(formId, 'formId');
        throwIfNotDefined(formHistoryId, 'formHistoryId');
        const pathParams = {
            formId,
            formHistoryId
        };
        return this.get({
            path: '/api/enterprise/editor/form-models/{formId}/history/{formHistoryId}',
            pathParams,
            returnType: FormRepresentation
        });
    }
    getForm(formId) {
        throwIfNotDefined(formId, 'formId');
        const pathParams = {
            formId
        };
        return this.get({
            path: '/api/enterprise/editor/form-models/{formId}',
            pathParams,
            returnType: FormRepresentation
        });
    }
    getForms(input) {
        if (typeof input === 'string') {
            const queryParams = {
                formId: buildCollectionParam(input, 'multi')
            };
            return this.get({
                path: '/api/enterprise/editor/form-models/values',
                queryParams,
                returnType: FormRepresentation
            });
        }
        else if (typeof input === 'object') {
            return this.get({
                path: '/api/enterprise/forms',
                queryParams: input
            });
        }
        else {
            return this.get({
                path: '/api/enterprise/editor/form-models',
                returnType: ResultListDataRepresentationFormRepresentation
            });
        }
    }
    saveForm(formId, saveRepresentation) {
        throwIfNotDefined(formId, 'formId');
        throwIfNotDefined(saveRepresentation, 'saveRepresentation');
        const pathParams = {
            formId
        };
        return this.put({
            path: '/api/enterprise/editor/form-models/{formId}',
            pathParams,
            bodyParam: saveRepresentation,
            returnType: FormRepresentation
        });
    }
    validateModel(formId, saveRepresentation) {
        throwIfNotDefined(formId, 'formId');
        throwIfNotDefined(saveRepresentation, 'saveRepresentation');
        const pathParams = {
            formId
        };
        return this.get({
            path: '/api/enterprise/editor/form-models/{formId}/validate',
            pathParams,
            bodyParam: saveRepresentation
        });
    }
}
